import { API, axiosInstance } from "lib";




export const updateCommonUserLrData = (data = {}) => {
    return axiosInstance
        .get(
            API.UPDATE_USER_LR_COLUMNS, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                console.log(err)
            }
      //      throw err;
        });
};